var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgICloudIcoGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0115 6.72691L20.0153 6.69991C20.0151 5.28843 19.5444 3.91728 18.6777 2.80325C17.811 1.68921 16.5976 0.895854 15.2295 0.548602C13.8614 0.201351 12.4166 0.320021 11.1235 0.885851C9.83043 1.45168 8.76282 2.43238 8.0895 3.67291C5.89425 2.52466 3.2415 4.02466 3.10125 6.50116C2.19241 6.83225 1.40738 7.43484 0.852612 8.22721C0.297847 9.01958 0.000187927 9.96339 0 10.9307C0.000198855 12.1822 0.497442 13.3823 1.38238 14.2673C2.26732 15.1522 3.4675 15.6495 4.719 15.6497H19.5278C25.1603 15.6339 25.614 7.35691 20.0123 6.72766L20.0115 6.72691Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgICloudIcoGray);
export default __webpack_public_path__ + "static/media/iCloudIcoGray.ca4633655e09161b3ee5e39504344806.svg";
export { ForwardRef as ReactComponent };